import moment from "moment-timezone";
import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";

import Button from "@/components/UI/Button";
import { Button2 } from "@/ui2/atoms/Button";
import { getAutomationDataAttr } from "@/utils/automationUtils";
import images from "@/utils/images";
import Input from "@/components/UI/Input";
import { toTitleCase } from "@/utils/filters";

const PendingPatientListItem = (props) => {
  const { archiveBtnHandler, patient, resendBtnHandler } = props;

  const { contacted, created_date } = patient;

  const name = toTitleCase(patient.first_name + " " + patient.last_name);
  const createdDate = created_date
    ? moment(parseFloat(created_date) * 1000).format("MM/DD/YYYY")
    : null;

  const formatMobileNumber = (val) => {
    let firstNumber = val.substring(0, 3);
    let middleNumber = val.substring(3, 6);
    let lastNumber = val.substring(6, 10);

    return `(${firstNumber}) ${middleNumber}-${lastNumber}`;
  };

  let mobileListItem = (
    <>
      <div className="d-flex d-lg-none justify-content-between">
        <div className="d-flex fs-14 flex-column" style={{ width: "65%", wordWrap: "break-word" }}>
          <span className="fs-16 tw:font-bold">{name}</span>
          <span>{patient.email}</span>
          <span>{formatMobileNumber(patient.mobile)}</span>
        </div>

        <div className="d-flex fs-14 flex-column">
          <span>{createdDate}</span>
          <div>{contacted ? "Contacted" : null}</div>
        </div>
      </div>

      <div className="d-flex d-lg-none justify-content-between mt-4">
        <Button2
          id={`archiveBtn-${patient["referral_code"]}`}
          isDisabled={patient.btnStatus}
          onPress={() => archiveBtnHandler(patient["referral_code"], name)}
          size="xs"
          variant="secondary"
        >
          Archive
        </Button2>

        <Button2
          isDisabled={patient.btnStatus}
          onPress={() => resendBtnHandler(patient.email)}
          size="xs"
        >
          {patient.btnText}
        </Button2>

        <Button
          className="Btn Btn--sec Btn-xs fs-12"
          onClick={() => props.history.push("/app/referral/" + patient["referral_code"])}
        >
          View
        </Button>
      </div>
    </>
  );

  let desktopListItem = (
    <div className="row no-gutters d-none d-lg-flex fs-14 align-items-center justify-content-between">
      <div
        className="col-2"
        data-placement="top"
        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
        title={name}
        {...getAutomationDataAttr("PendingPatientListItemPatientName")}
      >
        {name}
      </div>

      <div
        className="col-3"
        data-placement="top"
        style={{ overflow: "hidden", textOverflow: "ellipsis" }}
        title={patient.email}
      >
        {patient.email}
      </div>

      <div className="col-2">{formatMobileNumber(patient.mobile)}</div>
      <div className="col-1">{createdDate}</div>

      <div className="col-1">
        {contacted && (
          <Input
            checked={contacted ? "checked" : null}
            className="AddPatientInput ml-3"
            disabled
            name="contacted"
            type="checkbox"
          />
        )}
      </div>

      <div className="col-1">
        <Button2
          isDisabled={patient.btnStatus}
          onPress={() => archiveBtnHandler(patient["referral_code"], name)}
          size="xs"
          variant="secondary"
        >
          Archive
        </Button2>
      </div>

      <div className="col-1">
        <Button2
          isDisabled={patient.btnStatus}
          onPress={() => resendBtnHandler(patient.email)}
          size="xs"
        >
          {patient.btnText}
        </Button2>
      </div>

      <div className="col-1 d-flex d-flex tw:justify-center">
        <div className="cursor ml-5">
          <img
            alt="view icon"
            onClick={() => props.history.push("/app/referral/" + patient["referral_code"])}
            src={images("./common/view.png")}
            {...getAutomationDataAttr("ViewPendingPatient")}
          />
        </div>
      </div>
    </div>
  );

  return (
    <Fragment>
      {mobileListItem}
      {desktopListItem}
    </Fragment>
  );
};

export default withRouter(PendingPatientListItem);
